import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { List } from "immutable";
import { BaseModalContainer, DefaultListModalComponent, ModalContainerService, ModalService, QueryParameter, UserService } from "yt-ng-framework";
import { FilterWithOrgJedComponent } from "../../_filters/filter-with-org-jed.component";
import { EkranskaKarticaKomitenata } from "./ekranska-kartica-komitenata";

@Component({
    selector: 'ekranska-kartica-komitenta',
    templateUrl: './ekranska-kartica-komitenata.component.html'
})

export class EkranskaKarticaKomitenataComponent extends BaseModalContainer<EkranskaKarticaKomitenata> implements OnInit{
    
    @ViewChild("defaultList", { static: true }) defaultList: DefaultListModalComponent<EkranskaKarticaKomitenata>;
    @ViewChild("filterFak", { static: true }) filterFak: FilterWithOrgJedComponent;
  
    @Input() RefreshStatusClicked() {}

    parameterList: List<QueryParameter> = List([])

    constructor(
        protected modalContainerService: ModalContainerService<EkranskaKarticaKomitenata>,
        protected activatedRoute: ActivatedRoute,
        protected modalService: ModalService,
        protected userService: UserService
    ){
        super(modalContainerService, activatedRoute, modalService, userService)
    }

    ngOnInit() {
        super.ngOnInit();
        //this.defaultList.onmo
    }

    refreshStatus(oldToDays: number) {
        let __this=this;
        var odDana = new Date();
        odDana.setDate(odDana.getDate() - oldToDays);
        this.defaultList.mainItems.forEach(function (value) {
          const jsDate = new Date(
            value["Datum"]["year"],
            value["Datum"]["month"] - 1,
            value["Datum"]["day"]
          );
        //   if (jsDate > odDana)
        //   {
        //     __this.OsveziStatus(value["ID"], true);
        //   };
        });
      }
    
    
      // applayFilter(data) {
      //   this.defaultList.LoadMainItems(true, data);
      //   // this.filterFak.RefreshStatusClick();
      // }
}